var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"e-chat__message--typing"},[_vm._v(" "+_vm._s(_vm.text)+" "),_c('span'),_c('span'),_c('span')])}
var staticRenderFns = []

export { render, staticRenderFns }